import React, {Component, Fragment} from 'react';
import './PackagesList.css';
import Header from './Header/Header';
import PackageItem from './PackageItem/PackageItem';
import Package from './../Package/Package';
import Modal from './../UI/Modal/Modal';

class PackagesList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      packModalShow: false,
      packIdModal: 1
    }
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {    
    // console.log("outer open");
    const {skreen} = this.props;
    if(skreen == "desktop"){
      document.body.style.overflow = 'hidden';
      this.setState({
        packModalShow: true,
        packIdModal:e.target.dataset['id']
      });
    }
  }

  closeModal() {
    // console.log("outer close");
    const {skreen} = this.props;
    if(skreen == "desktop"){
      document.body.style.overflow = 'auto';
      this.setState({
        packModalShow: false,
        packIdModal: 1
      });
    }
  }

  render() {
    // console.log("pl render", this.props);
    const {skreen, packs} = this.props;
    let modal = null;
    if(skreen === "desktop"){
      modal = <Modal 
      style={ {
        backdrop:{},
        modal:{top:60},
        close:{backgroundColor: 'rgb(70, 70, 70, 0.0)', top:-62, right:0}
      }} 
      iconClose = {<i className="fas fa-times"></i>}
      show={this.state.packModalShow} modalClosed={this.closeModal}>
        <Package 
        forceClose={!this.state.packModalShow} 
        packs={packs} skreen={skreen} 
        match={{params:{packageID:this.state.packIdModal}}}></Package>
      </Modal>
    }
    

    return (
      <Fragment>
        <div className="container">
          <Header />
          
          <div className="packages-list" style={{backgroundColor:'pink'}}>
          {
            packs.map( (pack, id) => 
              <PackageItem key={id} {...pack} skreen={skreen} openModal={this.openModal} />
            )
          }
          </div>
        </div>
        {modal}
      </Fragment>
    );
  }
}

export default PackagesList;
